/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { NatsCaller } from "../NatsCaller";
import type {
  CreateDependenciesRequest,
  CreateDependenciesResponse,
  CreateLinkTypeRequest,
  CreateLinkTypeResponse,
  CreateLinksRequest,
  CreateLinksResponse,
  CreateObjectiveLinkRequest,
  CreateTimerEventRequest,
  CreateTimerEventResponse,
  DeleteLinkRequest,
  DeleteLinksRequest,
  DeleteObjectiveLinkRequest,
  EmptyResponse,
  GetAlmStickiesAcrossSessionsRequest,
  GetAlmStickiesAcrossSessionsResponse,
  GetAlmStickiesRequest,
  GetAlmStickiesResponse,
  GetArtsResponse,
  GetBoardResponse,
  GetBoardsResponse,
  GetBurndownChartDataRequest,
  GetBurndownChartDataResponse,
  GetCapacityAllocationRequest,
  GetCapacityAllocationResponse,
  GetDependenciesResponse,
  GetDependencyFlowRequest,
  GetDependencyFlowResponse,
  GetIterationsResponse,
  GetLinkTypeResponse,
  GetLinkTypesResponse,
  GetLinksRequest,
  GetLinksResponse,
  GetParticipatingUsersResponse,
  GetPlanningDatesResponse,
  GetPredictabilityRequest,
  GetPredictabilityResponse,
  GetSessionNameResponse,
  GetSessionResponse,
  GetSessionTeamIdsMappingRequest,
  GetSessionTeamIdsMappingResponse,
  GetSessionsResponse,
  GetSettingsResponse,
  GetStatusDistributionRequest,
  GetStatusDistributionResponse,
  GetStickerTypesResponse,
  GetStickiesByBoardIdsRequest,
  GetStickiesByBoardIdsResponse,
  GetStickiesRequest,
  GetStickiesResponse,
  GetStickyChangesResponse,
  GetStickyResponse,
  GetTeamsResponse,
  GetTimerEventsResponse,
  HasStickiesOfTypeOnBoardsRequest,
  HasStickiesOfTypeOnBoardsResponse,
  HasStickiesOfTypeRequest,
  HasStickiesOfTypeResponse,
  SearchStickiesRequest,
  SearchStickiesResponse,
  SetIterationsRequest,
  SetParticipatingUsersRequest,
  SetPlanningDatesRequest,
  SetSessionNameRequest,
  SetSettingsRequest,
  SetStickerTypesRequest,
  SetStickerTypesResponse,
  UpdateLinkTypeRequest,
  UpdateTimerEventRequest,
} from "./models";
import {
  createDependenciesResponseSchema,
  createLinkTypeResponseSchema,
  createLinksResponseSchema,
  createTimerEventResponseSchema,
  emptyResponseSchema,
  getAlmStickiesAcrossSessionsResponseSchema,
  getAlmStickiesResponseSchema,
  getArtsResponseSchema,
  getBoardResponseSchema,
  getBoardsResponseSchema,
  getBurndownChartDataResponseSchema,
  getCapacityAllocationResponseSchema,
  getDependenciesResponseSchema,
  getDependencyFlowResponseSchema,
  getIterationsResponseSchema,
  getLinkTypeResponseSchema,
  getLinkTypesResponseSchema,
  getLinksResponseSchema,
  getParticipatingUsersResponseSchema,
  getPlanningDatesResponseSchema,
  getPredictabilityResponseSchema,
  getSessionNameResponseSchema,
  getSessionResponseSchema,
  getSessionTeamIdsMappingResponseSchema,
  getSessionsResponseSchema,
  getSettingsResponseSchema,
  getStatusDistributionResponseSchema,
  getStickerTypesResponseSchema,
  getStickiesByBoardIdsResponseSchema,
  getStickiesResponseSchema,
  getStickyChangesResponseSchema,
  getStickyResponseSchema,
  getTeamsResponseSchema,
  getTimerEventsResponseSchema,
  hasStickiesOfTypeOnBoardsResponseSchema,
  hasStickiesOfTypeResponseSchema,
  searchStickiesResponseSchema,
  setStickerTypesResponseSchema,
} from "./schemas";

export class NatsSessionClient {
  constructor(private caller: NatsCaller) {}

  async getUserSessions(): Promise<GetSessionsResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.session.v1.sessions.get";
    return await this.caller.request(subject, "getUserSessions", {}, getSessionsResponseSchema);
  }

  async getBoards(session_id: string): Promise<GetBoardsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.boards.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getBoards", {}, getBoardsResponseSchema);
  }

  async getAlmStickies(
    payload: GetAlmStickiesRequest,
    session_id: string,
  ): Promise<GetAlmStickiesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.alm_stickies.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getAlmStickies",
      payload,
      getAlmStickiesResponseSchema,
    );
  }

  async getAlmStickiesAcrossSessions(
    payload: GetAlmStickiesAcrossSessionsRequest,
  ): Promise<GetAlmStickiesAcrossSessionsResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.session.v1.alm_stickies.get";
    return await this.caller.request(
      subject,
      "getAlmStickiesAcrossSessions",
      payload,
      getAlmStickiesAcrossSessionsResponseSchema,
    );
  }

  async getIterations(session_id: string): Promise<GetIterationsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.iterations.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getIterations", {}, getIterationsResponseSchema);
  }

  async getTeams(session_id: string): Promise<GetTeamsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.teams.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getTeams", {}, getTeamsResponseSchema);
  }

  async getSessionTeamIdsMapping(
    payload: GetSessionTeamIdsMappingRequest,
  ): Promise<GetSessionTeamIdsMappingResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.session.v1.session_team_ids_mappings.get";
    return await this.caller.request(
      subject,
      "getSessionTeamIdsMapping",
      payload,
      getSessionTeamIdsMappingResponseSchema,
    );
  }

  async getArts(session_id: string): Promise<GetArtsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.arts.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getArts", {}, getArtsResponseSchema);
  }

  async getSession(session_id: string): Promise<GetSessionResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getSession", {}, getSessionResponseSchema);
  }

  async archive(session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.archive".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "archive", {}, emptyResponseSchema);
  }

  async delete(session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.delete".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "delete", {}, emptyResponseSchema);
  }

  async getDependencies(session_id: string): Promise<GetDependenciesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.dependencies.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getDependencies", {}, getDependenciesResponseSchema);
  }

  async addDependencies(
    payload: CreateDependenciesRequest,
    session_id: string,
  ): Promise<CreateDependenciesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.dependencies.create".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "addDependencies",
      payload,
      createDependenciesResponseSchema,
    );
  }

  async getSettings(session_id: string): Promise<GetSettingsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.settings.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getSettings", {}, getSettingsResponseSchema);
  }

  async setSettings(payload: SetSettingsRequest, session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.settings.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "setSettings", payload, emptyResponseSchema);
  }

  async getLinkTypes(session_id: string): Promise<GetLinkTypesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.link_types.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getLinkTypes", {}, getLinkTypesResponseSchema);
  }

  async createLinkType(
    payload: CreateLinkTypeRequest,
    session_id: string,
  ): Promise<CreateLinkTypeResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.link_types.create".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "createLinkType",
      payload,
      createLinkTypeResponseSchema,
    );
  }

  async getLinkType(session_id: string, link_type_id: string): Promise<GetLinkTypeResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.link_types.${link_type_id}.get"
        .replace("${session_id}", session_id)
        .replace("${link_type_id}", link_type_id);
    return await this.caller.request(subject, "getLinkType", {}, getLinkTypeResponseSchema);
  }

  async updateLinkType(
    payload: UpdateLinkTypeRequest,
    session_id: string,
    link_type_id: string,
  ): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.link_types.${link_type_id}.update"
        .replace("${session_id}", session_id)
        .replace("${link_type_id}", link_type_id);
    return await this.caller.request(subject, "updateLinkType", payload, emptyResponseSchema);
  }

  async deleteLinkType(session_id: string, link_type_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.link_types.${link_type_id}.delete"
        .replace("${session_id}", session_id)
        .replace("${link_type_id}", link_type_id);
    return await this.caller.request(subject, "deleteLinkType", {}, emptyResponseSchema);
  }

  async getLinksInSession(session_id: string): Promise<GetLinksResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.links.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getLinksInSession", {}, getLinksResponseSchema);
  }

  async addLinks(payload: CreateLinksRequest, session_id: string): Promise<CreateLinksResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.links.create".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "addLinks", payload, createLinksResponseSchema);
  }

  async deleteLinks(payload: DeleteLinksRequest, session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.links.delete".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "deleteLinks", payload, emptyResponseSchema);
  }

  async getSticky(sticky_id: string): Promise<GetStickyResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.session.v1.stickies.${sticky_id}.get".replace(
      "${sticky_id}",
      sticky_id,
    );
    return await this.caller.request(subject, "getSticky", {}, getStickyResponseSchema);
  }

  async getStickyChanges(sticky_id: string): Promise<GetStickyChangesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.stickies.${sticky_id}.changes.get".replace(
        "${sticky_id}",
        sticky_id,
      );
    return await this.caller.request(
      subject,
      "getStickyChanges",
      {},
      getStickyChangesResponseSchema,
    );
  }

  async getBoard(board_id: string): Promise<GetBoardResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.session.v1.boards.${board_id}.get".replace(
      "${board_id}",
      board_id,
    );
    return await this.caller.request(subject, "getBoard", {}, getBoardResponseSchema);
  }

  async getLinksByStickyIds(payload: GetLinksRequest): Promise<GetLinksResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.session.v1.links.get";
    return await this.caller.request(
      subject,
      "getLinksByStickyIds",
      payload,
      getLinksResponseSchema,
    );
  }

  async deleteLink(payload: DeleteLinkRequest, link_id: string): Promise<EmptyResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.session.v1.links.${link_id}.delete".replace(
      "${link_id}",
      link_id,
    );
    return await this.caller.request(subject, "deleteLink", payload, emptyResponseSchema);
  }

  async getSessionName(session_id: string): Promise<GetSessionNameResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.name.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getSessionName", {}, getSessionNameResponseSchema);
  }

  async setSessionName(payload: SetSessionNameRequest, session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.name.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "setSessionName", payload, emptyResponseSchema);
  }

  async getPlanningDates(session_id: string): Promise<GetPlanningDatesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.planning_dates.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getPlanningDates",
      {},
      getPlanningDatesResponseSchema,
    );
  }

  async setPlanningDates(
    payload: SetPlanningDatesRequest,
    session_id: string,
  ): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.planning_dates.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "setPlanningDates", payload, emptyResponseSchema);
  }

  async getParticipatingUsers(session_id: string): Promise<GetParticipatingUsersResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.participating_users.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getParticipatingUsers",
      {},
      getParticipatingUsersResponseSchema,
    );
  }

  async setParticipatingUsers(
    payload: SetParticipatingUsersRequest,
    session_id: string,
  ): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.participating_users.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "setParticipatingUsers",
      payload,
      emptyResponseSchema,
    );
  }

  async setIterations(payload: SetIterationsRequest, session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.iterations.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "setIterations", payload, emptyResponseSchema);
  }

  async getStickerTypes(session_id: string): Promise<GetStickerTypesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.sticker_types.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getStickerTypes", {}, getStickerTypesResponseSchema);
  }

  async setStickerTypes(
    payload: SetStickerTypesRequest,
    session_id: string,
  ): Promise<SetStickerTypesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.sticker_types.set".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "setStickerTypes",
      payload,
      setStickerTypesResponseSchema,
    );
  }

  async unarchive(session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.unarchive".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "unarchive", {}, emptyResponseSchema);
  }

  async getStickies(payload: GetStickiesRequest, session_id: string): Promise<GetStickiesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.stickies.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getStickies", payload, getStickiesResponseSchema);
  }

  async searchStickies(
    payload: SearchStickiesRequest,
    session_id: string,
  ): Promise<SearchStickiesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.stickies.search".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "searchStickies",
      payload,
      searchStickiesResponseSchema,
    );
  }

  async hasStickiesOfType(
    payload: HasStickiesOfTypeRequest,
    session_id: string,
  ): Promise<HasStickiesOfTypeResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.stickies.has_of_type.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "hasStickiesOfType",
      payload,
      hasStickiesOfTypeResponseSchema,
    );
  }

  async getStickiesByBoardIds(
    payload: GetStickiesByBoardIdsRequest,
    session_id: string,
  ): Promise<GetStickiesByBoardIdsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.stickies.by_board_ids.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getStickiesByBoardIds",
      payload,
      getStickiesByBoardIdsResponseSchema,
    );
  }

  async hasStickiesOfTypeOnBoards(
    payload: HasStickiesOfTypeOnBoardsRequest,
    session_id: string,
  ): Promise<HasStickiesOfTypeOnBoardsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.stickies.has_of_type_on_boards.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "hasStickiesOfTypeOnBoards",
      payload,
      hasStickiesOfTypeOnBoardsResponseSchema,
    );
  }

  async deleteUnusedStickyType(session_id: string, sticky_type_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.sticky_types.${sticky_type_id}.unused.delete"
        .replace("${session_id}", session_id)
        .replace("${sticky_type_id}", sticky_type_id);
    return await this.caller.request(subject, "deleteUnusedStickyType", {}, emptyResponseSchema);
  }

  async createObjectiveLink(payload: CreateObjectiveLinkRequest): Promise<EmptyResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.session.v1.objective_links.create";
    return await this.caller.request(subject, "createObjectiveLink", payload, emptyResponseSchema);
  }

  async deleteObjectiveLink(
    payload: DeleteObjectiveLinkRequest,
    objective_link_id: string,
  ): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.objective_links.${objective_link_id}.delete".replace(
        "${objective_link_id}",
        objective_link_id,
      );
    return await this.caller.request(subject, "deleteObjectiveLink", payload, emptyResponseSchema);
  }

  async createTimerEvent(
    payload: CreateTimerEventRequest,
    session_id: string,
  ): Promise<CreateTimerEventResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.timers.create".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "createTimerEvent",
      payload,
      createTimerEventResponseSchema,
    );
  }

  async deleteTimerEvent(session_id: string, timer_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.timers.${timer_id}.delete"
        .replace("${session_id}", session_id)
        .replace("${timer_id}", timer_id);
    return await this.caller.request(subject, "deleteTimerEvent", {}, emptyResponseSchema);
  }

  async getTimerEvents(session_id: string): Promise<GetTimerEventsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.timers.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getTimerEvents", {}, getTimerEventsResponseSchema);
  }

  async updateTimerEvent(
    payload: UpdateTimerEventRequest,
    session_id: string,
    timer_id: string,
  ): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.timers.${timer_id}.update"
        .replace("${session_id}", session_id)
        .replace("${timer_id}", timer_id);
    return await this.caller.request(subject, "updateTimerEvent", payload, emptyResponseSchema);
  }

  async getStatusDistribution(
    payload: GetStatusDistributionRequest,
    session_id: string,
  ): Promise<GetStatusDistributionResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.status_distribution.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getStatusDistribution",
      payload,
      getStatusDistributionResponseSchema,
    );
  }

  async getCapacityAllocation(
    payload: GetCapacityAllocationRequest,
    session_id: string,
  ): Promise<GetCapacityAllocationResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.analytics.capacity_allocation.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getCapacityAllocation",
      payload,
      getCapacityAllocationResponseSchema,
    );
  }

  async getDependencyFlow(
    payload: GetDependencyFlowRequest,
    session_id: string,
  ): Promise<GetDependencyFlowResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.analytics.dependency_flow.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getDependencyFlow",
      payload,
      getDependencyFlowResponseSchema,
    );
  }

  async getBurndown(
    payload: GetBurndownChartDataRequest,
    session_id: string,
  ): Promise<GetBurndownChartDataResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.analytics.burndown.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getBurndown",
      payload,
      getBurndownChartDataResponseSchema,
    );
  }

  async getPredictability(
    payload: GetPredictabilityRequest,
    session_id: string,
  ): Promise<GetPredictabilityResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.session.v1.sessions.${session_id}.analytics.predictability.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(
      subject,
      "getPredictability",
      payload,
      getPredictabilityResponseSchema,
    );
  }
}
